<template>
  <div class="json-viewer">
    <template v-for="(value, key) in toRaw(data)" :key="key">
      <div v-if="typeof value !== 'object' || value === null" class="my-2">
        <div class="d-flex">
          <span class="font-weight-bold mr-2">{{ formatKey(key) }}:</span>
          <span v-if="value === ''">
            <v-chip color="red"> Empty </v-chip>
          </span>
          <span v-else-if="value === null">
            <v-chip color="red"> NULL </v-chip>
          </span>
          <span v-else>{{ value }}</span>
        </div>
        <v-divider class="my-3" />
      </div>

      <div v-else-if="Array.isArray(value)">
        <strong>{{ formatKey(key) }}:</strong>
        <div class="json-array pl-8">
          <div
            v-for="(item, index) in value"
            :key="index"
            style="margin-bottom: 8px; border-left: 3px solid #ccc; padding-left: 8px"
          >
            <TJsonViewer :data="item" />
          </div>
        </div>
      </div>

      <div v-else>
        <strong>{{ formatKey(key) }}:</strong>
        <div class="pl-8">
          <TJsonViewer :data="value" />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { toRaw } from 'vue'

defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const formatKey = (key: string | number): string => {
  if (typeof key === 'number') key = key.toString()
  return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}
</script>
